/* @flow */

// $FlowFixMe – flow having troubles with dot inside module name
import {lory} from 'lory.js';
import { removeClasses } from './utils';
import arrayFrom from 'array-from';

type HeroState = {
  slidesCount: number,
  currentSlide: number,
}

class HeroCarousel {
  current: ?HTMLElement;
  count: ?HTMLElement;
  dots: HTMLElement;
  templateListItem: HTMLElement;
  instance: Object;
  state: HeroState;
  timerId: number;
  INITIAL_SLIDE: number;

  constructor() {
    const node = document.querySelector('.js-hero-carousel');
    this.INITIAL_SLIDE = 0;
    this.dots = document.querySelector('.js-hero-carousel-dots');
    this.current = document.querySelector('.js-hero-carousel-current');
    this.count = document.querySelector('.js-hero-carousel-count');
    this.templateListItem = document.createElement('li');
    this.templateListItem.classList.add('c-hero__dot');

    if (!node || !this.dots) {
      return;
    }

    this.state = {
      slidesCount: arrayFrom(node.querySelectorAll('.o-lory__slide')).length,
      currentSlide: this.INITIAL_SLIDE
    }

    this.setupListeners();
    this.initLory(node, this.dots);
  }

  setupListeners() {
    const scrollToTop = document.querySelectorAll('.js-hero-iframe-scrolltop');
    arrayFrom(scrollToTop).forEach(element => {
      element.addEventListener('click', event => {
        const exhibitId = event.target.closest('.js-hero-iframe-scrolltop')
          .getAttribute('data-scroll-exhibit');
        this.setState({ currentSlide: Number(exhibitId)});
      });
    });
  }

  initLory(node: HTMLElement, dots: HTMLElement) {
    this.setupEvents(node, dots);

    this.instance = lory(node, {
      classNameFrame: 'o-lory__frame',
      classNameSlideContainer: 'o-lory__container',
      classNamePrevCtrl: 'o-lory__prev',
      classNameNextCtrl: 'o-lory__next',
    });

    dots.children[1].classList.add('is-lure');

    this.startAutoslide();
  }

  startAutoslide() {
    const TIMEOUT = 5000; // milliseconds
    this.pauseAutoslide();
    this.timerId = setTimeout(() => this.setState({currentSlide: this.state.currentSlide + 1}), TIMEOUT);
  }

  pauseAutoslide() {
    clearTimeout(this.timerId);
  }

  setupEvents(node: HTMLElement, dots: HTMLElement) {
    node.addEventListener('before.lory.init', () => {
      this.handleDotsBeforeInit(dots);
    });
    node.addEventListener('after.lory.init', () => {
      this.handleDotsAfterInit(dots);
    });
    node.addEventListener('before.lory.slide', () => {
      this.pauseAutoslide();
    });
    node.addEventListener('on.lory.touchmove', () => {
      this.pauseAutoslide();
    });
    node.addEventListener('on.lory.touchend', () => {
      this.startAutoslide();
    });
    node.addEventListener('after.lory.slide', () => {
      this.setState({ currentSlide: this.instance.returnIndex() });
      this.startAutoslide();
    });
  }

  handleDotsBeforeInit(dots: HTMLElement) {
    for (let i = 0; i < this.state.slidesCount; i++) {
      const clone = this.templateListItem.cloneNode();
      dots.appendChild(clone);
    }
    dots.children[this.state.currentSlide].classList.add('active');
  }

  handleDotsAfterInit(dots: HTMLElement) {
    arrayFrom(dots.children).forEach(node => {
      node.addEventListener('click', event => {
        const currentSlide = arrayFrom(dots.children).indexOf(event.target);
        this.setState({currentSlide});
      })
    });
  }

  handleDotsAfterSlide(dots: HTMLElement) {
    arrayFrom(dots.children).forEach(node => {
      node.classList.remove('active');
    });

    this.state.currentSlide = this.instance.returnIndex();

    dots.children[this.state.currentSlide].classList.add('active');
    removeClasses(dots.children, 'is-lure');
  }

  setState(newState: Object) {
    this.state = Object.assign({}, this.state, newState);
    this.updateSlideshow();
  }

  updateSlideshow() {
    if (this.state.currentSlide >= this.state.slidesCount) {
      this.setState({ currentSlide: this.INITIAL_SLIDE });
    }

    if (this.state.currentSlide !== this.instance.returnIndex()) {
      this.instance.slideTo(this.state.currentSlide);
    }

    this.handleDotsAfterSlide(this.dots);
  }
}

export default HeroCarousel;
